import { useQuery } from 'react-query'
import { fetchMyAccess, type MyAccess } from '@/lib/access'
import { getAccessToken } from '@/lib/session'

export function useMyAccess() {
  return useQuery<MyAccess>({
    queryKey: ['me', 'access'],
    queryFn: fetchMyAccess,
    enabled: !!getAccessToken(),
    staleTime: 1000 * 60 * 5
  })
}
